import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { PriceContainerProps } from "../../interfaces/containers";
import Price from "../../components/SellModal/Price/Price";
import { getAdditionalExpensesSalePost, setPrice, setSuggestedPrices, setIsPaid, setFinancingBonus,postPublication, setIsNegotiate, setNegotiatePercentage } from "../../actions/salePost";
import { setLoginRedirection } from "../../actions/auth";

function mapStateToProps(state: PriceContainerProps) {
    return{
        vehiclePaid: state.salePost.vehiclePaid,
        negotiatePrice: state.salePost.negotiatePrice,
        suggestedPrices: state.salePost.suggestedPrices, 
        fetchingSuggedtedPrices: state.salePost.fetchingSuggedtedPrices,
        additionalCost: state.salePost.additionalCost,
        user: state.auth.user,
        fetchingAdditionalCost: state.salePost.fetchingAdditionalCost,
        plate: state.salePost.plate,
        price: state.salePost.price,
        isFoundPlate: state.salePost.isFoundPlate,
        negotiatePercentage: state.salePost.negotiatePercentage,
        salePost: state.salePost
    }
}
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        setSuggestedPrices,
        setPrice,
        setLoginRedirection,
        getAdditionalExpensesSalePost,
        setFinancingBonus,
        setIsNegotiate,
        setIsPaid,
        setNegotiatePercentage,
        postPublication
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Price);